import React from "react";
import { Link } from "react-router-dom";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RTooltip } from "recharts";
import { GrcCard, RAG_COLORS } from "./shared";

export const GapDonut = ({ gaps, assessmentId }) => {
  const g = gaps || {};
  const slices = [
    { name: "Critical", value: g.critical || 0, color: RAG_COLORS.RED },
    { name: "Major", value: g.major || 0, color: RAG_COLORS.AMBER },
    { name: "Minor", value: g.minor || 0, color: RAG_COLORS.YELLOW },
    { name: "Passed", value: g.pass || 0, color: RAG_COLORS.GREEN },
  ];
  const totalGaps = (g.critical || 0) + (g.major || 0) + (g.minor || 0);
  const hasData = slices.some((s) => s.value > 0);
  return (
    <GrcCard
      title="Overall Gap Summary"
      info="Distribution of assessment gaps by severity. 'Total gaps' excludes PASS results. SA1–SA6 screening questions are excluded upstream."
      infoTestId="info-gap-summary"
      testId="card-gap-summary"
    >
      <div className="flex items-center gap-3">
        <div className="relative h-32 w-32 shrink-0">
          {hasData ? (
            <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={100}>
              <PieChart>
                <Pie data={slices} dataKey="value" innerRadius={40} outerRadius={58} paddingAngle={2} stroke="none">
                  {slices.map((s) => (
                    <Cell key={s.name} fill={s.color} />
                  ))}
                </Pie>
                <RTooltip formatter={(v, n) => [v, n]} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-full w-full rounded-full border-8 border-slate-100" />
          )}
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <span data-testid="gap-total-value" className="text-xl font-bold text-[#003366]">
              {totalGaps}
            </span>
            <span className="text-[10px] text-slate-500">Total Gaps</span>
          </div>
        </div>
        <ul className="space-y-1.5 text-xs" data-testid="gap-legend">
          {slices.map((s) => (
            <li key={s.name} className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: s.color }} />
              <span className="font-semibold text-[#003366]">{s.value}</span>
              <span className="text-slate-500">{s.name}</span>
            </li>
          ))}
        </ul>
      </div>
      <Link
        to={`/assessment/${assessmentId}/findings`}
        data-testid="view-all-findings-link"
        className="block mt-2 text-center text-xs font-medium text-[#008080] hover:underline"
      >
        View all findings →
      </Link>
    </GrcCard>
  );
};
